"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var webAApi_1 = require("../../../../api/webAApi");
var BonusTemplateCfgZonesListCtl = /** @class */ (function (_super) {
    __extends(BonusTemplateCfgZonesListCtl, _super);
    function BonusTemplateCfgZonesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_player_zone_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_zone_id; });
        _this.dk_player_zone_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_zone_title; });
        _this.dk_player_status_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_status_code; });
        _this.dk_player_status_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_status_title; });
        _this._errDialog = errDialog;
        return _this;
    }
    BonusTemplateCfgZonesListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    BonusTemplateCfgZonesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "bonus template segments list with id [" + id + "] not found !";
    };
    BonusTemplateCfgZonesListCtl.prototype.LoadData = function (bonusTplCurrencyConfigId, onDone) {
        var _this = this;
        webAApi_1.ListBonusTemplateConfigSegmentItemsByTemplateIdGet.exec({
            data: {
                bonus_template_currency_config_id: bonusTplCurrencyConfigId
            }
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    player_zone_id: resp.list[i].player_zone_id,
                    player_zone_title: resp.list[i].player_zone_title,
                    player_status_code: resp.list[i].player_status_code,
                    player_status_title: resp.list[i].player_status_title
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BonusTemplateCfgZonesListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBonusTemplateConfigSegmentItem.exec({
            data: {
                bonus_template_currency_config_id: data.bonus_template_currency_config_id,
                player_status_code: data.player_status_code,
                player_zone_id: data.player_zone_id
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.bonus_zone_key,
                player_zone_id: data.player_zone_id,
                player_zone_title: resp.player_zone_title,
                player_status_code: data.player_status_code,
                player_status_title: resp.player_status_title
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BonusTemplateCfgZonesListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.bonus_segment_key);
        if (_tmp) {
            webAApi_1.DoEditBonusTemplateConfigSegmentItem.exec({
                data: {
                    bonus_template_currency_config_id: data.bonus_template_currency_config_id,
                    bonus_segment_key: data.bonus_segment_key,
                    player_status_code: data.player_status_code,
                    player_zone_id: data.player_zone_id
                }
            }, function (resp) {
                _tmp.player_status_code = data.player_status_code;
                _tmp.player_zone_id = data.player_zone_id;
                _tmp.player_zone_title = resp.player_zone_title;
                _tmp.player_status_title = resp.player_status_title;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BonusTemplateCfgZonesListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    BonusTemplateCfgZonesListCtl.prototype.DeleteData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.bonus_segment_key);
        if (_tmp) {
            webAApi_1.DoDeleteBonusTemplateConfigSegmentItem.exec({
                data: {
                    bonus_segment_key: data.bonus_segment_key,
                    bonus_template_currency_config_id: data.bonus_template_currency_config_id
                }
            }, function (resp) {
                _this.RemoveItem(data.bonus_segment_key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return BonusTemplateCfgZonesListCtl;
}(BaseController_1.BaseController));
exports.BonusTemplateCfgZonesListCtl = BonusTemplateCfgZonesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_bonus_templates/ctl/BonusTemplateCfgZonesListCtl.ts
// module id = 1038
// module chunks = 0